const AMPLITUDE_EVENT_PROPERTIES = {
    EVENT_PROPERTIES: 'event_properties',
    IQOS_PRODUCT_DEVICE_ID: 'iqos_product_device_id',
    IQOS_PRODUCT_MODEL_TYPE: 'iqos_product_model_type',
    SETTING_VALUE: 'setting_value',
    SETTING_TYPE: 'setting_type',
    SOURCE: 'source',
    MODE: 'mode',
    SUCCESS: 'success',
    ERROR_MESSAGE: 'error_message',
    DATA_SYNC_COMPLETED: 'data_sync_completed',
    ERROR_CODE: 'error_code',
    CONNECTION_TYPE: 'connection_type',
    RESOLUTION_MESSAGE: 'resolution_message',
    DIAGNOSTIC_MESSAGE: 'diagnostic_message',
};

export default AMPLITUDE_EVENT_PROPERTIES;
